export default __webpack_public_path__ + "static/media/05_OTP.867d6f7a.svg";